import { gql } from "@apollo/client";

export const CONTACT_FIELDS = gql`
  fragment ContactFields on Contact {
    _id
    authorId
    schemaType
    category
    status
    state
    keywords
    identity
    reach
    files
    data
    ref {
      id
      collection
    }
    domain
    propertyListIds
    createdAt
    updatedAt
  }
`;

// Slim list/card fragment. `identity` and `reach` are JSONObject scalars the
// cards render directly; the heavyweight `data` bag (provenance, externalIds,
// research) is only fetched for the selected contact via GET_CONTACT, or via
// GET_CONTACTS_FULL for flows that need it in bulk (bulk email, verify).
export const CONTACT_CARD_FIELDS = gql`
  fragment ContactCardFields on Contact {
    _id
    authorId
    ref {
      id
      collection
    }
    identity
    reach
    status
    category
    state
    domain
    propertyListIds
    createdAt
    updatedAt
  }
`;

export const GET_CONTACTS = gql`
  query GetAddressbookContacts($input: ContactsInput!) {
    contacts(input: $input) {
      total
      contacts {
        ...ContactCardFields
      }
    }
  }
  ${CONTACT_CARD_FIELDS}
`;

export const GET_CONTACTS_FULL = gql`
  query GetAddressbookContactsFull($input: ContactsInput!) {
    contacts(input: $input) {
      total
      contacts {
        ...ContactFields
      }
    }
  }
  ${CONTACT_FIELDS}
`;

export const GET_CONTACT = gql`
  query GetAddressbookContact($id: ID!, $authorId: String!) {
    contact(id: $id, authorId: $authorId) {
      ...ContactFields
    }
  }
  ${CONTACT_FIELDS}
`;
